type Option<T extends any> = {
  value: T
  label: string
}

export enum ZOOM_ENUM {
  MAX = 0,
  YTD = -1,
  FOUR_FULL_QUARTERS = -2,
}

type MAX = ZOOM_ENUM.MAX
type YTD = ZOOM_ENUM.YTD
type FOUR_FULL_QUARTERS = ZOOM_ENUM.FOUR_FULL_QUARTERS
export type ZoomValues =
  | YTD
  | MAX
  | FOUR_FULL_QUARTERS
  | 1
  | 7
  | 30
  | 90
  | 180
  | 365
export type ZoomOption = Option<ZoomValues> & {
  tooltip: string
  disabled?: boolean
}

const DEFAULT_ZOOM: Array<ZoomOption> = [
  {
    label: "7D",
    value: 7,
    tooltip: `Show past week.`,
  },
  {
    label: "30D",
    value: 30,
    tooltip: `Show past month.`,
  },
  {
    label: "90D",
    value: 90,
    tooltip: `Show past quarter.`,
  },
  {
    label: "180D",
    value: 180,
    tooltip: `Show past 6 months.`,
  },
  {
    label: "YTD",
    value: ZOOM_ENUM.YTD,
    tooltip: `Show year to date.`,
  },
  {
    label: "365D",
    value: 365,
    tooltip: `Show past year.`,
  },
]

const MAX: ZoomOption = {
  label: "MAX",
  value: ZOOM_ENUM.MAX,
  tooltip: `Show since launch.`,
}

const LATEST: ZoomOption = {
  label: "Latest",
  value: 1,
  tooltip: `Show latest.`,
}

export const ZOOM_WITH_MAX = [...DEFAULT_ZOOM, MAX]

export const ZOOM_WITH_LATEST = [LATEST, ...DEFAULT_ZOOM]
